import moment from 'moment';
import { get } from 'lodash';
import { readRuleAsMoment } from './utils';
import * as types from "../constants";

export function parsePermitSeasonInfo(aggSeasonRules, timeZone, divisionId = '', permitRules = null) {
  return {
    seasonStart: readRuleAsMoment("SeasonStart", aggSeasonRules, timeZone, divisionId),
    seasonEnd: readRuleAsMoment("SeasonEnd", aggSeasonRules, timeZone, divisionId),
    lotterySeasonStart: readRuleAsMoment("HighUseSeasonStart", aggSeasonRules, timeZone, divisionId),
    lotterySeasonEnd: readRuleAsMoment("HighUseSeasonEnd", aggSeasonRules, timeZone, divisionId),
    lotteryDisplayDate: readRuleAsMoment('LotteryDisplayDate', !permitRules ? aggSeasonRules: permitRules, timeZone, divisionId),
    lotteryReleaseDate: readRuleAsMoment('LotteryReleaseDate', !permitRules ? aggSeasonRules : permitRules, timeZone, divisionId)
  };
}

export function isDayWithinSeason(day, permitSeasonInfo) {
  return permitSeasonInfo.seasonStart.isValid()
    && permitSeasonInfo.seasonEnd.isValid()
    && day.isBetween(permitSeasonInfo.seasonStart, permitSeasonInfo.seasonEnd, 'days', '[]');
}

export function isDayWithinLotterySeason(day, permitSeasonInfo) {
  return permitSeasonInfo.lotterySeasonStart.isValid()
    && permitSeasonInfo.lotterySeasonEnd.isValid()
    && day.isBetween(permitSeasonInfo.lotterySeasonStart, permitSeasonInfo.lotterySeasonEnd, 'days', '[]');
}

export function isDayManagedByLottery(day, permitSeasonInfo, currentDate) {
  return isDayWithinLotterySeason(day, permitSeasonInfo)
    && permitSeasonInfo.lotteryDisplayDate.isValid()
    && permitSeasonInfo.lotteryReleaseDate.isValid()
    && currentDate.isBetween(permitSeasonInfo.lotteryDisplayDate, permitSeasonInfo.lotteryReleaseDate, "[]", true);
}

export function isDayBeingBlockedByLottery(day, permitSeasonInfo, currentDate, blockLotteryDates) {
  return blockLotteryDates && isDayManagedByLottery(day, permitSeasonInfo, currentDate);
}

export function isDayBlocked(day, permitSeasonInfo, currentDate, blockNonLotteryDates, blockLotteryDates, availBools) {
  if (day.isBefore(currentDate)) {
    return true;
  }
  if (!isDayWithinSeason(day, permitSeasonInfo)) {
    return true;
  }
  if (blockNonLotteryDates && !isDayWithinLotterySeason(day, permitSeasonInfo)) {
    return true;
  }
  if (isDayBeingBlockedByLottery(day, permitSeasonInfo, currentDate, blockLotteryDates)) {
    return true;
  }
  if (!availBools) {
    return true;
  }
  return !availBools[day.format(types.AVAILABILITY_KEY_MAP_FORMAT)];
}

// returns first available day for either lottery or reservation based on params of avail date map and aggregate season information
export const findNextAvailableDay = (availBools, permitSeasonInfo, blockNonLotteryDates, blockLotteryDates, currentTime) => {
  let nextDate = null;
  Object.keys(availBools).forEach((date) => {
    if (!nextDate) {
      if (!isDayBlocked(
          moment(date, types.AVAILABILITY_KEY_MAP_FORMAT).utc(),
          permitSeasonInfo,
          currentTime,
          blockNonLotteryDates,
          blockLotteryDates,
          availBools
        )) {
        nextDate = moment(date, types.AVAILABILITY_KEY_MAP_FORMAT);
      }
    }
  });

  return nextDate;
};

export function getDateAvailabilityTooltip(day, availability) {
  // calculate tooltip
  const dateString = moment(day).utcOffset(0, true).format();
  const tooltip = ['Available'];
  for (const quota in availability.quota_type_maps) {
    if (Object.prototype.hasOwnProperty.call(availability.quota_type_maps, quota)) {
      let { remaining = 0 } = get(availability, `quota_type_maps[${quota}][${dateString}]`, {})
      if (remaining > 99) {
        remaining = '99+';
      }
      else if (remaining < 0) {
        remaining = 0;
      }
      if (quota === types.GROUP_AVAILABILITY_KEY_NAME || quota === types.GROUP_AVAILABILITY_DAILY_KEY_NAME) {
        tooltip.push(`\u000AGroups: ${remaining}`);
      }
      if (quota === types.MEMBER_AVAILABILITY_KEY_NAME) {
        tooltip.push(`\u000APeople: ${remaining}`);
      }
      if (quota === types.WATERCRAFT_AVAILABILITY_KEY_NAME) {
        tooltip.push(`\u000AWatercraft: ${remaining}`);
      }
      if (quota === types.MAX_STOCK_KEY_NAME) {
        tooltip.push(`\u000AStock: ${remaining}`);
      }
    }
  }


  return tooltip;
}
